import { useQuery } from '@tanstack/react-query';

import { useApi, useAuth } from '../../hooks';

type Coach = {
  id: string;
  capacity: number;
  first_name: string;
  healthie_id: number;
  last_name: string;
};

export const useFetchCoaches = () => {
  const { api } = useApi();
  const { userToken } = useAuth();

  const fetchCoaches = async () => {
    return await api({
      route: '/private/dashboard/coaches',
      token: userToken,
    });
  };

  const { data, isLoading, isError } = useQuery<Coach[], Error>({
    queryFn: () => fetchCoaches(),
    queryKey: ['dashboard-coaches'],
  });

  return {
    data,
    isLoading,
    isError,
  };
};
